<template>
  <div
    id="kt_header_mobile"
    class="header-mobile align-items-center"
    v-bind:class="headerClasses"
  >
    <div class="d-flex align-items-center">
      <!--begin::Aside Mobile Toggle-->
      <button
        v-if="asideEnabled"
        class="btn p-0 mr-3 burger-icon burger-icon-left"
        id="kt_aside_mobile_toggle"
        @click.prevent="toggleAside"
      >
        <span></span>
      </button>
      <!--end::Aside Mobile Toggle-->

      <!--begin::Logo-->
      <div class="brand-logo">
        <router-link class="text-white" to="/">
          <img v-if="false" :src="siteLogo()" alt="Logo" />
          <strong class="uppercase">ЛЮНИК ЕООД</strong>
        </router-link>
      </div>
      <!--end::Logo-->
    </div>

    <!--begin::Toolbar-->
    <KTTopbar mobile-inline />
    <!--end::Toolbar-->
  </div>
</template>

<style lang="scss" scoped>
@media (max-width: 991.98px) {
  .header-mobile ::v-deep .topbar--mobile-inline .btn-clean {
    color: #fff;
  }
}
</style>

<script>
import { mapGetters } from "vuex";
import KTTopbar from "@/view/layout/header/Topbar.vue";
import KTLayoutAside from "@/assets/js/layout/base/aside.js";

export default {
  name: "KTHeaderMobile",
  components: {
    KTTopbar
  },
  methods: {
    toggleAside() {
      const aside = KTLayoutAside.getOffcanvas();
      if (!aside) return;

      if (aside.isShown()) {
        aside.hide();
      } else {
        aside.show();
      }
    }
  },
  computed: {
    ...mapGetters(["layoutConfig", "getClasses"]),

    /**
     * Get header logo
     * @returns {string}
     */
    headerLogo() {
      return process.env.BASE_URL + this.layoutConfig("self.logo.dark");
    },

    /**
     * Get classes for mobile header
     * @returns {null|*}
     */
    headerClasses() {
      const classes = this.getClasses("header_mobile");
      if (typeof classes !== "undefined") {
        return classes.join(" ");
      }
      return null;
    },

    /**
     * Check if the left aside menu is enabled
     * @returns {boolean}
     */
    asideEnabled() {
      return !!this.layoutConfig("aside.self.display");
    }
  },
};
</script>
